// extracted by mini-css-extract-plugin
module.exports = {"mightOverflow":"FormComponents_mightOverflow__3aY4m Tables_mightOverflow__2b9f3","ellipsisPopup":"FormComponents_ellipsisPopup__sLVsV"};